module.exports = __webpack_public_path__ + "img/bt_map_zoomin_default.cf9796e5.svg";